// extracted by mini-css-extract-plugin
export var aircallIframe = "_gf-3";
export var fabContainer = "_gf-5";
export var fabRinging = "_gf-6";
export var loadingOverlay = "_gf-4";
export var pulse = "_gf-7";
export var widgetContent = "_gf-2";
export var widgetPanel = "_gf-0";
export var widgetPanelExpanded = "_gf-1";